module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-3a9973ca!./packages/dof-modal/colmo.css
// module id = 464
// module chunks = 0 1